module.exports = __webpack_public_path__ + "static/media/holding-apple-cut.c4a9d6dc.jpeg";